import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { REDUCER_NAME } from './slice';

const getRoot = prop([REDUCER_NAME]);

export const getDocumentsToReview = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'documentsToReview'));
export const getMyDocuments = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'myDocuments'));
export const getWaves = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'waves'));
export const getRegions = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'regions'));
export const getSuperiors = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'superiors'));
export const getSubordinates = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'subordinates'));
export const getClientsDocumentsToReview = createSelector(
	getRoot,
	propOr(EMPTY_VALUES.ARRAY, 'clientsDocumentsToReview'),
);
export const getClientsMyDocuments = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'clientsMyDocuments'));
export const getUserIsSuperior = createSelector(getRoot, propOr(false, 'userIsSuperior'));
export const getUserIsSuperiorAndSubordinate = createSelector(getRoot, propOr(false, 'userIsSuperiorAndSubordinate'));
export const getMyDocumentsTotalRows = createSelector(getRoot, propOr(0, 'myDocumentsTotalRows'));
export const getShowMyDocuments = createSelector(getRoot, propOr(0, 'showMyDocuments'));
